<div class="row">
  <div class="col-12">
    <app-checkout-headline
      [showSubHeadline]="false"
      headline="{{ 'habaCheckoutReview.review' | cxTranslate }}"
    ></app-checkout-headline>
    <app-pending-registration-notice />
  </div>

  <div class="col-12">
    <!-- ROW 1 -->
    @if (companyBillingAddress?.customerType !== NewCustomerType.Private) {
      <div class="row card-row">
        <button
          class="mb-6 mb-md-10 p-6 review-section"
          [attr.data-qa]="habaQa?.deliveryAddress"
          (click)="editModal('personal-data')"
        >
          <div class="d-flex justify-content-between spacing">
            <h4 class="heading-lato">{{ 'habaCheckoutReview.cardTitle.client' | cxTranslate }}</h4>
            <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
          </div>
          <app-view-address
            *ngIf="companyBillingAddress"
            [baseId]="baseQaId"
            [qaIdAddressType]="'billingAddress'"
            [address]="companyBillingAddress"
            name="delivery-address"
            class="fs-16"
          />
        </button>
        <button
          class="mb-6 mb-md-10 p-6 review-section"
          [attr.data-qa]="habaQa?.billingAddress"
          (click)="editModal('client-contact-person')"
        >
          <div class="d-flex justify-content-between spacing">
            <h4 class="heading-lato">
              {{ 'habaCheckoutReview.cardTitle.clientContactPerson' | cxTranslate }}
            </h4>
            <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
          </div>
          @if (isGuestCart) {
            <p class="text-left lato-normal fs-16">
              {{ companyBillingAddress?.firstName }} {{ companyBillingAddress?.lastName }} <br />
              {{ companyBillingAddress?.phone }}
            </p>
          } @else {
            @if (user$ | async; as user) {
              <p class="text-left lato-normal fs-16">
                {{ user.firstName }} {{ user.lastName }} <br />
                {{ user.phoneNumber }}
              </p>
            }
          }
        </button>
      </div>
    }
    <!-- ROW 2 -->
    <div class="row card-row heading-lato">
      <button
        class="mb-6 mb-md-10 p-6 review-section"
        [attr.data-qa]="habaQa?.deliveryAddress"
        (click)="editModal('shipping-address')"
      >
        <div class="d-flex justify-content-between spacing">
          <h4 class="heading-lato">
            {{ 'habaCheckoutReview.cardTitle.shippingAddress' | cxTranslate }}
          </h4>
          <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
        </div>
        <app-view-address
          *ngIf="deliveryAddress"
          [baseId]="baseQaId"
          [qaIdAddressType]="'deliveryAddress'"
          [address]="deliveryAddress"
          name="delivery-address"
          class="fs-16"
        ></app-view-address>
      </button>
      <button
        class="mb-6 mb-md-10 p-6 review-section"
        [attr.data-qa]="habaQa?.billingAddress"
        (click)="
          editModal(
            companyBillingAddress?.customerType === NewCustomerType.Private
              ? 'private-billing-address'
              : 'billing-address'
          )
        "
      >
        <div class="d-flex justify-content-between spacing">
          <h4 class="heading-lato">
            {{ 'habaCheckoutReview.cardTitle.billingAddress' | cxTranslate }}
          </h4>

          <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
        </div>
        <app-view-address
          [baseId]="baseQaId"
          [address]="billingAddress"
          name="billing-address"
          class="fs-16"
        />
      </button>
    </div>
    <!-- ROW 3 -->
    <div class="row card-row heading-lato">
      @if (showDeliveryContact) {
        <button
          class="mb-6 mb-md-10 p-6 review-section"
          [attr.data-qa]="habaQa?.billingAddress"
          (click)="editModal('delivery-contact-person')"
        >
          <div class="d-flex justify-content-between spacing">
            <h4 class="heading-lato">
              {{ 'habaCheckoutReview.cardTitle.contactPerson' | cxTranslate }}
            </h4>
            <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
          </div>
          <p class="text-left lato-normal fs-16">
            {{ deliveryAddress?.firstName }} {{ deliveryAddress?.lastName }} <br />
            {{ deliveryAddress?.phone }}
          </p>
        </button>
      }
      <button
        class="mb-6 mb-md-10 p-6 review-section d-flex flex-column"
        [attr.data-qa]="habaQa?.billingAddress"
        (click)="editModal('email-invoice')"
      >
        <div class="d-flex justify-content-between spacing">
          <h4 class="heading-lato">
            {{ 'habaCheckoutReview.cardTitle.emailInvoice' | cxTranslate }}
          </h4>
          <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
        </div>
        <p class="text-left lato-normal fs-16">
          @if (invoiceEmail) {
            {{ invoiceEmail }}
          } @else {
            @if ((user$ | async)?.email) {
              {{ (user$ | async)?.email }}
            }
          }
        </p>
      </button>
    </div>
    <!-- ROW 4 -->
    <div class="row card-row heading-lato">
      <div class="mb-6 mb-md-10 p-6 review-section">
        <div class="d-flex justify-content-between spacing">
          <h4 class="heading-lato">
            {{ 'habaCheckoutReview.cardTitle.deliveryMethod' | cxTranslate }}
          </h4>
        </div>
        <div class="fs-16">{{ 'habaCheckoutReview.default' | cxTranslate }}</div>
      </div>
      <button
        class="mb-6 mb-md-10 p-6 review-section"
        [attr.data-qa]="habaQa?.paymentMethod"
        (click)="editModal('payment-mode')"
      >
        <div class="d-flex justify-content-between spacing">
          <h4 class="heading-lato">
            {{ 'habaCheckoutReview.cardTitle.paymentMethod' | cxTranslate }}
          </h4>
          <app-svg [iconName]="'Edit'" dimension="1rem"></app-svg>
        </div>
        <div *ngIf="paymentDetails" class="d-flex">
          <img [src]="paymentDetailsImage()" style="width: 110px" [alt]="paymentDetails.id" />
        </div>
      </button>
    </div>
  </div>
</div>

<app-checkout-products></app-checkout-products>

<ng-container *ngIf="cart$ | async as cart">
  <app-applied-promotions-disclaimer
    class="pt-10 d-none d-md-block"
    [orderPromotions]="cart.appliedOrderPromotions"
    [productPromotions]="cart.appliedProductPromotions"
  ></app-applied-promotions-disclaimer>
</ng-container>
